export function removeCharacters(string: string) {

    const characters = ['(', ')', '/']

    characters.forEach(char => {
        string = string.replaceAll(char, '')
    })
    return string
}